import { PREDICTED_CAPITALIZATION_STATUS_LABELS } from '@common/neo.tax';

import { ColumnDefinition, FilterSortDataType } from '@neo.tax/shared';

export const BASE_FILTERABLE_ASC_PROJECT_COLUMNS = [
  { name: 'name', label: 'Name', dataType: FilterSortDataType.TEXT },
  { name: 'productName', label: 'Product', dataType: FilterSortDataType.TEXT },
  { name: 'workstreamNamesSearch', label: 'Teams', dataType: FilterSortDataType.TEXT },
  {
    name: 'predictedCapitalizationStatus',
    label: 'AI Guidance',
    dataType: FilterSortDataType.ENUM,
    enum: Object.entries(PREDICTED_CAPITALIZATION_STATUS_LABELS).map(([value, label]) => ({ value, label })),
  },
  { name: 'capitalizationStartDate', label: 'Capitalization Start', dataType: FilterSortDataType.MONTH_YEAR_START },
  { name: 'capitalizationEndDate', label: 'Capitalization End', dataType: FilterSortDataType.MONTH_YEAR_END },
  {
    name: 'isCapitalized',
    label: 'Capitalized',
    dataType: FilterSortDataType.BOOLEAN,
  },
  { name: 'projectOwnerName', label: 'Project Owner', dataType: FilterSortDataType.TEXT },
] as const satisfies readonly ColumnDefinition<string>[];

export const CAPITALIZABLE_PROJECT_CLUSTERING_FILTER_COLUMN = {
  name: 'capitalizableProjectClustering',
  label: 'Next Sync Matching',
  dataType: FilterSortDataType.ENUM,
  enum: [
    { value: 'ACTIVE', label: 'Active' },
    { value: 'INACTIVE', label: 'Inactive' },
  ],
} as const satisfies ColumnDefinition<string>;

type AscProjectFilterableColumnName =
  | (typeof BASE_FILTERABLE_ASC_PROJECT_COLUMNS)[number]['name']
  | typeof CAPITALIZABLE_PROJECT_CLUSTERING_FILTER_COLUMN.name;

export const getFilterableAscProjectColumns = (
  isCapitalizedProjectClustering: boolean,
): readonly ColumnDefinition<AscProjectFilterableColumnName>[] =>
  isCapitalizedProjectClustering
    ? [...BASE_FILTERABLE_ASC_PROJECT_COLUMNS, CAPITALIZABLE_PROJECT_CLUSTERING_FILTER_COLUMN]
    : BASE_FILTERABLE_ASC_PROJECT_COLUMNS;

export const getSortableAscProjectColumns = (
  _isCapitalizedProjectClustering: boolean,
): readonly ColumnDefinition<AscProjectFilterableColumnName>[] => BASE_FILTERABLE_ASC_PROJECT_COLUMNS;
